<div class="tiltak-beskrivelse">

    <h1>
        {{tiltak().tittel}}
    </h1>

    <p>
        {{tiltak().beskrivelse}}
    </p>

    @if (tiltak().image; as image) {
            <img [src]="image.uri" class="image"  [alt]="image.bildetekst ?? ''">
    }

    @if (tiltak().begrunnelse) {
        <p class="description">{{ tiltak().begrunnelse }}</p>
    }
</div>
